<div class="float-right d-none d-sm-block">
  <b>Version</b>
  {{ appVersion }}
</div>
<strong>
  <span>Copyright &copy; {{ currentYear }}</span>
  Informa di Bianchi Maria
  <span>.</span>
</strong>
<span>All rights reserved.</span>
